import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, User, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const LOGO_URL = "https://customer-assets.emergentagent.com/job_cafm-restructure/artifacts/o51eebue_597817161_1172388751673908_7998470242494796850_n.jpg";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!credentials.username || !credentials.password) {
      toast.error("Inserisci username e password");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${API}/admin/login`, credentials);
      
      // Store token in localStorage
      localStorage.setItem("adminToken", response.data.token);
      
      toast.success("Accesso effettuato!");
      navigate("/admin/dashboard");
    } catch (error) {
      console.error("Login error:", error);
      toast.error(error.response?.data?.detail || "Credenziali non valide");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          {/* Logo */}
          <div className="text-center mb-8">
            <img
              src={LOGO_URL}
              alt="CAF Patronato EPAS"
              className="h-20 w-auto mx-auto mb-4"
            />
            <h1 className="font-heading text-2xl font-bold text-slate-900">
              Area Amministratore
            </h1>
            <p className="text-slate-500 text-sm mt-2">
              Accedi per gestire appuntamenti e disponibilità
            </p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="username" className="flex items-center gap-2">
                <User className="w-4 h-4" />
                Username
              </Label>
              <Input
                id="username"
                type="text"
                value={credentials.username}
                onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
                placeholder="admin"
                className="h-12"
                data-testid="admin-username"
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="password" className="flex items-center gap-2">
                <Lock className="w-4 h-4" />
                Password
              </Label>
              <Input
                id="password"
                type="password"
                value={credentials.password}
                onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                placeholder="••••••••"
                className="h-12"
                data-testid="admin-password"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full h-12 bg-blue-900 hover:bg-blue-800 text-white rounded-full"
              data-testid="admin-login-btn"
            >
              {loading ? (
                "Accesso in corso..."
              ) : (
                <>
                  Accedi
                  <ArrowRight className="w-4 h-4 ml-2" />
                </>
              )}
            </Button>
          </form>

          {/* Back Link */}
          <div className="mt-6 text-center">
            <a
              href="/"
              className="text-sm text-slate-500 hover:text-blue-900 transition-colors"
              data-testid="back-to-site"
            >
              ← Torna al sito
            </a>
          </div>
        </div>

        {/* Info Box */}
        <div className="mt-6 bg-slate-800 rounded-xl p-4 text-center">
          <p className="text-slate-400 text-sm">
            Accesso riservato al personale autorizzato
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
